import { actions as experimentActions } from '@saucelabs/sl-module-experiments';

import { actions, constants } from '.';

export const initialize = (user) => (dispatch) => (
  Promise.all([
    dispatch(actions.getSubaccounts(user.username)),
    dispatch(experimentActions.getExperiment(constants.MULTIPLE_TEAMS_EXPERIMENT)),
  ])
    .then(() => dispatch(actions.initialized()))
);

let instance;
export const unsubscribeTransfer = () => (dispatch) => {
  dispatch(actions.unsubscribeTransferStatus());
  instance = null;
};

export const subscribeTransfer = (payload) => (dispatch) => {
  if (instance) return null;
  dispatch(actions.subscribeTransferStatus());
  instance = () => {
    dispatch(actions.openLoadingModal());
    dispatch(actions.getTransferStatus(payload, { skipErrorPage: true }))
      .then(({ data }) => {
        if (data.status === constants.TRANSFER_COMPLETE_STATUS) {
          dispatch(unsubscribeTransfer());
          dispatch(actions.redirectToTeamManagement());
          return;
        }

        if (data.status === constants.TRANSFER_FAILED_STATUS) {
          dispatch(unsubscribeTransfer());
          dispatch(actions.showError(true));
          dispatch(actions.hideLoadingModal());
          return;
        }

        setTimeout(() => instance(payload), 5000);
      })
      .catch(({ data }) => {
        dispatch(unsubscribeTransfer());
        dispatch(actions.showError((data && (data.error || data.message)) || true));
        dispatch(actions.hideLoadingModal());
      });
  };
  return instance();
};

export const submitForm = (payload) => (dispatch) => (
  dispatch(actions.transferOrganization(payload, { skipErrorPage: true }))
    .then(({ data }) => dispatch(subscribeTransfer(data.uuid)))
    .catch(({ data }) => (
      dispatch(actions.showError((data && (data.error || data.message)) || true))
    ))
);
